// extracted by mini-css-extract-plugin
export var btn = "button-module--btn--ycsIs";
export var icon = "button-module--icon--4bRz3";
export var label = "button-module--label--1YgVZ";